import { useCallback, useState } from "react";

export const useRowActions = ({ projectId, reload, openId, openBundle }) => {
const [rowLoading, setRowLoading] = useState({}); // { [id]: {submit:true,...} }

const setRowAL = useCallback((inspectionId, key, val) => {
setRowLoading((p) => ({
    ...p,
    [inspectionId]: { ...(p[inspectionId] || {}), [key]: val },
}));
}, []);

const run = useCallback(
async (inspectionId, key, fn) => {
    if (!projectId || !inspectionId) return;
    setRowAL(inspectionId, key, true);
    try {
    await fn();
    await reload?.();
    if (openId === inspectionId) await openBundle(inspectionId);
    } finally {
    setRowAL(inspectionId, key, false);
    }
},
[projectId, reload, openId, openBundle, setRowAL]
);

return { rowLoading, run };
};
